import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Forest, Tree } from '../../types';

interface ForestState {
  currentForest: Forest | null;
  trees: Tree[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ForestState = {
  currentForest: null,
  trees: [],
  isLoading: false,
  error: null,
};

const forestSlice = createSlice({
  name: 'forest',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    
    setCurrentForest: (state, action: PayloadAction<Forest>) => {
      state.currentForest = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    
    setTrees: (state, action: PayloadAction<Tree[]>) => {
      state.trees = action.payload;
    },
    
    addTree: (state, action: PayloadAction<Tree>) => {
      state.trees.push(action.payload);
    },
    
    updateTree: (state, action: PayloadAction<Tree>) => {
      const index = state.trees.findIndex(tree => tree.id === action.payload.id);
      if (index !== -1) {
        state.trees[index] = action.payload;
      }
    },
    
    removeTree: (state, action: PayloadAction<string>) => {
      state.trees = state.trees.filter(tree => tree.id !== action.payload);
    },
    
    clearForest: (state) => {
      state.currentForest = null;
      state.trees = [];
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setError,
  setCurrentForest,
  setTrees,
  addTree,
  updateTree,
  removeTree,
  clearForest,
} = forestSlice.actions;

export default forestSlice.reducer;